module.exports = __webpack_public_path__ + "static/humans-f74a906474fc3b79d2157622572f0e9d.png";